<template>
    <div :class="containerClass">
        <div 
            :title="title" 
            :class="imageClass" 
            :style="getImageUrl(item)"
            role="img"
            :aria-label="`Image of ${item.DisplayName}`"
        >
        </div>
    </div>
</template>

<script>
import menuItemMixin from '../../../js/mixins/menuItemMixin';

export default {
    name: 'menu-item-image',
    mixins: [menuItemMixin],
    props: {
        item: {
            type: Object,
            required: true
        },
        size: {
            type: String,
            default: 'large', // 'large' or 'small'
            validator: value => ['large', 'small'].includes(value)
        },
        title: {
            type: String,
            default: 'Menu Item Image'
        }
    },
    computed: {
        containerClass() {
            return this.size === 'large' ? 'large-container' : 'small-container';
        },
        imageClass() {
            return this.size === 'large' ? 'large-image' : 'small-image';
        }
    }
}
</script>

<style scoped>
.large-container {
    flex: 1;
    width: 100%;
    min-width: 200px;
    max-width: 350px;
    margin: 0 auto;
}

.large-image {
    width: 100%;
    aspect-ratio: 1;
    border-radius: 16px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}

.small-container {
    flex-shrink: 0;
}

.small-image {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background-size: cover;
    background-position: center;
    background-repeat: no-repeat;
}
</style>